// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LeftChart_wrapper__2JbG6"};